import React, { useState, useEffect } from "react";
import "./Chat.css";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import Alert from "../../../Components/Alert/Alert";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../AuthContext";
import Axios from "axios";
import { useBaseUrl } from "../../../ApiContext";

export default function Chat() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const location = useLocation();
  const { id, from } = location.state || {};
  const [title, setTitle] = useState("");
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [chats, setChats] = useState([]);
  const [userMessage, setUserMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showSendingAlert, setShowSendingAlert] = useState(false);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const userMessageHandler = (e) => {
    setUserMessage(e.target.value);
  };
  useEffect(() => {
    const fetchTicket = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/tickets/${id}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setTitle(response.data.title);
        setChats(response.data.chats);
      } catch (error) {
        console.log("Error during getting ticket messages", error);
      }
    };
    if (userToken) {
      fetchTicket();
    }
  }, [baseUrl, userToken, id]);

  const handleSendMessage = async () => {
    if (userMessage.length > 0) {
      setShowSendingAlert(true);
      setTimeout(() => {
        setShowSendingAlert(false);
      }, 2000);
      try {
        const response = await Axios.post(
          `${baseUrl}/ticket/${id}/new_message`,
          { text: userMessage },
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        console.log("new messsage", response.data);
        setChats((prevChats) => [...prevChats, response.data]);
        setUserMessage("");
      } catch (error) {
        console.log("Error during sending message", error);
      }
    } else {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <h3 className="pageTitle horizontalBorder">{title}</h3>
          <div className="chatContainer centeredFlex">
            <div className="chatMessages scroll centeredFlex">
              {chats.length > 0 &&
                chats.map((chat, index) => (
                  <div
                    key={index}
                    className={`chatMessage ${
                      chat.from_admin ? "adminMessage" : "userMessage"
                    }`}
                  >
                    <h6>{chat.from_admin ? "ادمین رِدرُز" : "کاربر"}</h6>
                    <p>{chat.text}</p>
                    <div
                      className="chatSendTime centeredFlex"
                      style={
                        chat.from_admin ? { color: "#EEE" } : { color: "#999" }
                      }
                    >
                      {chat.created_at}
                    </div>
                  </div>
                ))}
            </div>
            <div className="chatSendMessage centeredFlex">
              <button className="sendMessageBtn centeredFlex">
                <SendSharpIcon
                  className="sendIcon"
                  onClick={handleSendMessage}
                />
              </button>
              <input
                type="text"
                className="typeMessageInput"
                value={userMessage}
                onChange={userMessageHandler}
              />
            </div>
            <Alert showAlert={showAlert} alertText="متن پیام نباید خالی باشد" />
            <Alert
              showAlert={showSendingAlert}
              alertText="در حال ارسال پیام..."
            />
          </div>
        </div>
      </div>
      <BottomBar prevPath={from} />
    </div>
  );
}
